



























import { GrupoDeCliente } from '@/models'
import { obrigatorio } from '@/shareds/regras-de-form'
import { Component, Prop, Vue } from 'vue-property-decorator'
import SeletorDeLojas from '../loja/SeletorDeLojas.vue'
import { GrupoDeClienteUseCase } from '@/usecases/cliente/GrupoDeClienteUseCase'

@Component({
	components: {
		SeletorDeLojas,
	},
}) 
export default class DialogoDeVincularGrupoDeCliente extends Vue {
	@Prop() idCliente!: string

	mostra = false
	gruposDeCliente: GrupoDeCliente[] = []
	grupoDeCliente: GrupoDeCliente | null = null

	grupoDeClienteUseCase = new GrupoDeClienteUseCase()

	obrigatorio = obrigatorio

	async mostrar() {
		this.mostra = true
		await this.buscarGruposDeCliente()
	}

	cancelar() {
		this.mostra = false
		this.grupoDeCliente = null
		this.gruposDeCliente = []
	}

	async concluir() {
		this.$emit("vincularGrupo", this.grupoDeCliente)
		this.mostra = false
		this.gruposDeCliente = []
	}

	async buscarGruposDeCliente(){
		this.gruposDeCliente = await this.grupoDeClienteUseCase.listarGruposDeCliente()
	}
}
